import { useTranslate } from "@similarweb/i18n-provider";

import { appsSdksSignalChangeTypeMap } from "app/pages/sales-intelligence/domain/signals/types/apps-signal";
import {
    getAppsSdksSignalEventActionText,
    getAppsSdksSignalEventInstalledForDays,
} from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getAppsSdksSignalEventText";
import { getSignalEventPeriod } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getSignalEventDate";
import type { AppsSdksSignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import signalsI18nKeys from "app/pages/sales-intelligence/sub-modules/signals/utils/i18n";

import NameStringWithTooltip from "./NameStringWithTooltip";
import { StyledSignalText } from "./styles";

type AppsSignalEventInfoProps = {
    signal: AppsSdksSignalEventDto;
    companyName: string;
    "data-automation"?: string;
};

const AppsSignalEventInfo = ({ signal, companyName, "data-automation": dataAutomation }: AppsSignalEventInfoProps) => {
    const { translate } = useTranslate();
    const { sdks, changeType } = signal;
    const installedForDays = getAppsSdksSignalEventInstalledForDays(signal);

    if (sdks.length === 1) {
        return installedForDays ? (
            <StyledSignalText data-automation={dataAutomation}>
                {translate(signalsI18nKeys.apps.companyOverview.installedFor, {
                    sdk: sdks[0],
                    period: getSignalEventPeriod(installedForDays),
                })}
            </StyledSignalText>
        ) : null;
    }

    return changeType !== appsSdksSignalChangeTypeMap.renewalComingUp ? (
        <NameStringWithTooltip
            names={[...sdks]}
            text={getAppsSdksSignalEventActionText(signal, companyName)}
        />
    ) : null;
};

export default AppsSignalEventInfo;
